// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsAndcondition_container__Ft-c5 {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #121212;
  color: #e0e0e0;
}

.TermsAndcondition_pageHeader__QbjYd {
  background: linear-gradient(to right, #1a1a1a, #2d2d2d);
  padding: 4rem 2rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #333;
}

.TermsAndcondition_headerContent__ITFVi {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.TermsAndcondition_title__mEzEp {
  font-size: 2.5rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 0.5rem;
  letter-spacing: 0.5px;
}

.TermsAndcondition_subtitle__CDbeG {
  color: #999;
  font-size: 1rem;
  font-weight: 400;
}

.TermsAndcondition_contentWrapper__zP-ou {
  flex: 1 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  margin-bottom: 3rem;
  width: 90%;
}

.TermsAndcondition_content__4vbHO {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #e0e0e0;
}

.TermsAndcondition_content__4vbHO h2 {
  color: #ffffff;
  font-size: 1.8rem;
  margin: 2rem 0 1rem;
  border-bottom: 1px solid #333;
  padding-bottom: 0.5rem;
}

.TermsAndcondition_content__4vbHO h3 {
  color: #ffffff;
  font-size: 1.4rem;
  margin: 1.5rem 0 1rem;
}

.TermsAndcondition_content__4vbHO p {
  margin-bottom: 1.2rem;
}

.TermsAndcondition_content__4vbHO ul, .TermsAndcondition_content__4vbHO ol {
  margin: 1rem 0;
  padding-left: 2rem;
}

.TermsAndcondition_content__4vbHO li {
  margin-bottom: 0.5rem;
}

.TermsAndcondition_content__4vbHO a {
  color: #64b5f6;
  text-decoration: none;
  transition: color 0.2s ease;
}

.TermsAndcondition_content__4vbHO a:hover {
  color: #90caf9;
  text-decoration: underline;
}

.TermsAndcondition_loadingContainer__byT91 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  gap: 1rem;
}

.TermsAndcondition_loadingText__2v0je {
  color: #999;
  font-size: 1.1rem;
}

.TermsAndcondition_loader__xxJr6 {
  width: 48px;
  height: 48px;
  border: 4px solid #333;
  border-top: 4px solid #64b5f6;
  border-radius: 50%;
  animation: TermsAndcondition_spin__nIw2K 1s linear infinite;
}

.TermsAndcondition_errorContainer__DuyAS {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  text-align: center;
  background-color: rgba(220, 53, 69, 0.1);
  color: #ff6b6b;
  border: 1px solid rgba(220, 53, 69, 0.2);
  border-radius: 8px;
  padding: 2rem;
  margin: 2rem;
}

@keyframes TermsAndcondition_spin__nIw2K {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .TermsAndcondition_pageHeader__QbjYd {
    padding: 2rem 1rem;
  }

  .TermsAndcondition_title__mEzEp {
    font-size: 2rem;
  }

  .TermsAndcondition_contentWrapper__zP-ou {
    padding: 1.5rem;
    width: 95%;
  }

  .TermsAndcondition_content__4vbHO {
    font-size: 1rem;
    line-height: 1.6;
  }
}

/* Print styles */
@media print {
  .TermsAndcondition_container__Ft-c5 {
    background: white;
  }

  .TermsAndcondition_contentWrapper__zP-ou {
    box-shadow: none;
    padding: 0;
  }

  .TermsAndcondition_content__4vbHO {
    color: black;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/terms/TermsAndcondition.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,2DAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: #121212;\n  color: #e0e0e0;\n}\n\n.pageHeader {\n  background: linear-gradient(to right, #1a1a1a, #2d2d2d);\n  padding: 4rem 2rem;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #333;\n}\n\n.headerContent {\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.title {\n  font-size: 2.5rem;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n  letter-spacing: 0.5px;\n}\n\n.subtitle {\n  color: #999;\n  font-size: 1rem;\n  font-weight: 400;\n}\n\n.contentWrapper {\n  flex: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  background: #1a1a1a;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  margin-bottom: 3rem;\n  width: 90%;\n}\n\n.content {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #e0e0e0;\n}\n\n.content h2 {\n  color: #ffffff;\n  font-size: 1.8rem;\n  margin: 2rem 0 1rem;\n  border-bottom: 1px solid #333;\n  padding-bottom: 0.5rem;\n}\n\n.content h3 {\n  color: #ffffff;\n  font-size: 1.4rem;\n  margin: 1.5rem 0 1rem;\n}\n\n.content p {\n  margin-bottom: 1.2rem;\n}\n\n.content ul, .content ol {\n  margin: 1rem 0;\n  padding-left: 2rem;\n}\n\n.content li {\n  margin-bottom: 0.5rem;\n}\n\n.content a {\n  color: #64b5f6;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.content a:hover {\n  color: #90caf9;\n  text-decoration: underline;\n}\n\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.loadingText {\n  color: #999;\n  font-size: 1.1rem;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #333;\n  border-top: 4px solid #64b5f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.errorContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  text-align: center;\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #ff6b6b;\n  border: 1px solid rgba(220, 53, 69, 0.2);\n  border-radius: 8px;\n  padding: 2rem;\n  margin: 2rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .pageHeader {\n    padding: 2rem 1rem;\n  }\n\n  .title {\n    font-size: 2rem;\n  }\n\n  .contentWrapper {\n    padding: 1.5rem;\n    width: 95%;\n  }\n\n  .content {\n    font-size: 1rem;\n    line-height: 1.6;\n  }\n}\n\n/* Print styles */\n@media print {\n  .container {\n    background: white;\n  }\n\n  .contentWrapper {\n    box-shadow: none;\n    padding: 0;\n  }\n\n  .content {\n    color: black;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TermsAndcondition_container__Ft-c5`,
	"pageHeader": `TermsAndcondition_pageHeader__QbjYd`,
	"headerContent": `TermsAndcondition_headerContent__ITFVi`,
	"title": `TermsAndcondition_title__mEzEp`,
	"subtitle": `TermsAndcondition_subtitle__CDbeG`,
	"contentWrapper": `TermsAndcondition_contentWrapper__zP-ou`,
	"content": `TermsAndcondition_content__4vbHO`,
	"loadingContainer": `TermsAndcondition_loadingContainer__byT91`,
	"loadingText": `TermsAndcondition_loadingText__2v0je`,
	"loader": `TermsAndcondition_loader__xxJr6`,
	"spin": `TermsAndcondition_spin__nIw2K`,
	"errorContainer": `TermsAndcondition_errorContainer__DuyAS`
};
export default ___CSS_LOADER_EXPORT___;
